import { UseVenueEventsService } from "@app-contexts/dashboard/features/events/data/services/events/useVenueEventsService";
import { UseVenueBasedMembershipGroupService } from "@app-contexts/dashboard/features/memberships/data/services/membership-group/useVenueBasedMembershipGroupService";
import { VenueSerializer } from "@app-contexts/dashboard/features/venues/data/types/venues";
import { UsePublicEventService } from "@app-contexts/public/features/event-detail/data/services/usePublicEventsService";
import { PublicVenueSerializer } from "@app-contexts/public/features/org-profile/data/types/public-venue";
import { UsePublicMembershipGroupsService } from "@shared/modules/memberships/data/services/usePublicMembershipGroupsService";
import { BestAvailableSeatingQueryParamsActionType } from "@shared/modules/seating/types/seating-types";
import { Dispatch } from "react";
import { BestAvailableTicketTypeSelectionDialog } from "./BestAvailableTicketTypeSelectionDialog.web";
import { BestAvailableMembershipLevelSelectionDialog } from "./BestAvailabletMembershipLevelSelectionDialog.web";

type BestAvailableTypeSelectionDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  updateBestAvailableQueryParams: Dispatch<BestAvailableSeatingQueryParamsActionType>;
  eventsService: () => UseVenueEventsService | UsePublicEventService;
  membershipService: () =>
    | UseVenueBasedMembershipGroupService
    | UsePublicMembershipGroupsService;
  slug: string;
  initialSelectedTicketTypes: Record<string, number>;
  initialSelectedMembershipLevels: Record<string, number>;
  isMembership: boolean;
  isEvent: boolean;
  typesOnMap: Array<number>;
  venueData?: PublicVenueSerializer | VenueSerializer | undefined;
};

export function BestAvailableTypeSelectionDialog({
  isOpen,
  onClose,
  updateBestAvailableQueryParams,
  eventsService,
  membershipService,
  slug,
  initialSelectedTicketTypes,
  initialSelectedMembershipLevels,
  isMembership,
  isEvent,
  typesOnMap,
  venueData,
}: BestAvailableTypeSelectionDialogProps) {
  return (
    <>
      {isEvent && (
        <BestAvailableTicketTypeSelectionDialog
          isOpen={isOpen}
          onClose={onClose}
          eventsService={eventsService}
          eventSlug={slug}
          updateBestAvailableQueryParams={updateBestAvailableQueryParams}
          initialSelectedTicketTypes={initialSelectedTicketTypes}
          typesOnMap={typesOnMap}
          venueData={venueData}
        />
      )}
      {isMembership && (
        <BestAvailableMembershipLevelSelectionDialog
          isOpen={isOpen}
          onClose={onClose}
          membershipService={membershipService}
          updateBestAvailableQueryParams={updateBestAvailableQueryParams}
          initialSelectedMembershipLevels={initialSelectedMembershipLevels}
          membershipGroupSlug={slug}
          typesOnMap={typesOnMap}
        />
      )}
    </>
  );
}
